import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchMe, getStoredToken } from '../services/authService';
import EmployeeRefer from '../pages/EmployeeRefer/EmployeeRefer';

/**
 * Administrators use Referral requested (admin inbox); redirect away from user referral form.
 */
export default function EmployeeReferRoute() {
  const [role, setRole] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    if (!getStoredToken()) {
      setRole(null);
      return undefined;
    }
    fetchMe()
      .then((me) => {
        if (!cancelled) setRole(me?.role ?? null);
      })
      .catch(() => {
        if (!cancelled) setRole(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (role === undefined) {
    return (
      <div className="ref-req-loading" style={{ padding: '2rem', color: '#6b7280' }}>
        Loading…
      </div>
    );
  }

  if (role === 'ADMIN') {
    return <Navigate to="/admin/referral-requests" replace />;
  }

  return <EmployeeRefer />;
}
